"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onOnline = void 0;
var onlineCallbacks = new Set();
function onOnline(callback) {
    onlineCallbacks.add(callback);
    return function () {
        onlineCallbacks.delete(callback);
    };
}
exports.onOnline = onOnline;
window.addEventListener('online', function () {
    var copy = new Set(onlineCallbacks);
    onlineCallbacks.clear();
    copy.forEach(function (cb) { return cb(); });
}, { passive: true });
//# sourceMappingURL=onOnline.js.map